import { swaggerSplitApi as api } from "../swaggerApi"

import { EventSubscriptionArgs } from "@app/data/eventsSubscription/types";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

const eventSubscriptionApiInject = api.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    publicEventSubscription: build.mutation<object, EventSubscriptionArgs>({
      query: (arg)=>({
        url: `/api/v1/events/participant/request/public/${arg.eventId}/${arg.userId}`,
        method: "PATCH"
      }),
      transformResponse: (res:any) => {
        return res
      },
      invalidatesTags: invalidatesTags,
    }),
    privateEventSubscription: build.mutation<object, EventSubscriptionArgs>({
      query: (arg)=>({
        url: `/api/v1/events/participant/request/private/${arg.eventId}/${arg.userId}`,
        method: "PATCH"
      }),
      invalidatesTags: invalidatesTags,
      transformResponse: (res:any) => {
        return res
      },
    }),
    privateEventDecline: build.mutation<object, EventSubscriptionArgs>({
      query: (arg)=>({
        url: `/api/v1/events/participant/request/private/decline/${arg.eventId}/${arg.userId}`,
        method: "PATCH"
      }),
      invalidatesTags: invalidatesTags,
      transformResponse: (res:any) => {
        return res
      },
    }),
    publicEventDecline: build.mutation<object, EventSubscriptionArgs>({
      query: (arg)=>({
        url: `/api/v1/events/participant/decline/${arg.eventId}/${arg.userId}`,
        method: "PATCH"
      }),
      invalidatesTags: invalidatesTags,
      transformResponse: (res:any) => {
        return res
      },
    }),
  })
})
function invalidatesTags(result: object | undefined, error: FetchBaseQueryError | undefined , arg: EventSubscriptionArgs) {
  if (result !== undefined) {
    return [{ type: 'Event', id: arg.eventId }]
  }
  if (error) {
    console.groupCollapsed("invalidatesTags - error")
    const {status } = error
    if (typeof status === "number"){
      console.log(`invalidatesTags error: ${status}`)
    }else {
      console.error(`invalidatesTags error: ${status} message: ${error.error}`)
    }
    console.groupEnd()
  }
  return []
}
export const {usePrivateEventSubscriptionMutation,
  usePublicEventSubscriptionMutation,
  usePublicEventDeclineMutation,
  usePrivateEventDeclineMutation} = eventSubscriptionApiInject
